import React, { useState } from 'react';
import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import {
  Toolbar,
  ToolbarButton,
  makeStyles,
  tokens,
  Divider,
  FluentProvider,
  webLightTheme,
} from '@fluentui/react-components';
import { ChevronRightRegular, ChevronDownRegular } from '@fluentui/react-icons';
import { IProcessTemplateMilestone } from '../../../../utils/types/IProcessTemplate';
import SpanWithLabel from '../../../common/SpanWithLabel';
import StackColumn from '../../../common/StackColumn';

interface ITemplateMilestoneContentProps {
  milestone: IProcessTemplateMilestone;
}

const useStyles = makeStyles({
  toolbar: {
    marginInlineStart: '-8px',
  },
  toolbarButton: {
    padding: '10px',
    backgroundColor: tokens.colorNeutralBackground3,
  },
  paddingTop: {
    paddingTop: '20px',
  },
});
const ProcessTemplateMilestoneDrilldownInfo = ({
  milestone,
}: ITemplateMilestoneContentProps): JSX.Element => {
  const styles = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleMilestoneDrilldownInfo = (): void => {
    setIsExpanded((prev) => !prev);
  };

  const buttonText = isExpanded ? 'Show Less' : 'View More';

  return (
    <Stack className={styles.paddingTop} tokens={{ childrenGap: 5 }}>
      <StackItem className={styles.paddingTop}>
        <Toolbar className={styles.toolbar} aria-label="Milestone Actions">
          <ToolbarButton
            type="button"
            aria-expanded={isExpanded}
            icon={isExpanded ? <ChevronDownRegular /> : <ChevronRightRegular />}
            onClick={toggleMilestoneDrilldownInfo}
            appearance="subtle"
            className={styles.toolbarButton}
          >
            {buttonText}
          </ToolbarButton>
        </Toolbar>
      </StackItem>

      {isExpanded && (
        <Stack tokens={{ childrenGap: 5 }}>
          <FluentProvider theme={webLightTheme}>
            <Divider style={{ padding: '12px 0' }} />
          </FluentProvider>
          <StackColumn>
            <SpanWithLabel labelText="Description" value={milestone.description} />
            <SpanWithLabel labelText="Attestation Text" value={milestone.attestationText} />
          </StackColumn>
        </Stack>
      )}
    </Stack>
  );
};

export default ProcessTemplateMilestoneDrilldownInfo;
